import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ConnectorService } from '../connector.service';

export interface CreateAccountResponse {
  validationKey: string;
}

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  constructor(
    private http: HttpClient,
    private connector: ConnectorService
  ) {}

  /**
   * Étape 1 : demande de création de compte (split) et récupération de la validationKey
   * @param socioId Identifiant du socio
   * @param email Nouvelle adresse email
   */
  requestSplitAccount(socioId: number, email: string): Observable<CreateAccountResponse> {
    const url = `${environment.backAPI}/compte/validation-for-split`;
    const body = { socioId, email: email };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.connector.token()
    });
    return this.http.post<CreateAccountResponse>(url, body, { headers });
  }

  /**
   * Étape 2 : validation du split avec le code reçu par email
   * @param socioId Identifiant du socio
   * @param email Nouvelle adresse email
   * @param accountValidationKey Clé de validation reçue
   */
  splitAccount(socioId: number, email: string, accountValidationKey: string): Observable<any> {
    const url = `${environment.backAPI}/compte/split-account`;
    const body = { newEmail: email, accountValidationKey: accountValidationKey, socioId: socioId };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.connector.token()
    });
    return this.http.post<any>(url, body, { headers });
  }
}
